import Vue from 'vue'
import Vuex from 'vuex'
import Firebase from 'firebase'
import config from './../firebase-config'

Vue.use(Vuex)

//
// https://firebase.google.com/docs/reference/js/firebase.database.Reference
// https://firebase.google.com/docs/database/web/read-and-write
// https://alexjoverm.github.io/2017/07/16/Lazy-load-in-Vue-using-Webpack-s-code-splitting/
//

let firebase = Firebase.initializeApp(config)
firebase.auth().onAuthStateChanged(user => {
  store.commit('setUser', user)
  let ref = firebase.database().ref('messages').orderByChild('timestamp')
  if (user) {
    let handle = ref.on('value', snapshot => {
      var array = []
      let messages = snapshot.val()
      for (let id in messages) {
        let m = messages[id]
        array.unshift({
          id: id,
          date: `${new Date(m.timestamp)}`,
          name: m.name,
          email: m.email,
          text: m.text
        })
      }
      store.commit('setMessages', array)
    })
    store.commit('onMessagesChange', handle)
  } else {
    store.commit('setMessages', [])
    ref.off('value', store.getters.onMessagesChange)
    store.commit('onMessagesChange', null)
  }
})

let store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    loading: true,
    user: null,
    onMessagesChange: null,
    messages: null,
    messageSent: false
    // products: [
    //   {id: '1', name: 'ShoTi'},
    //   {id: '2', name: 'ShootersPal'}
    // ]
  },
  mutations: {
    setUser (state, user) {
      if (user) {
        state.user = {
          uid: user.uid,
          email: user.email,
          refreshToken: user.refreshToken
        }
      } else {
        state.user = null
      }
      state.loading = false
    },
    onMessagesChange (state, handle) {
      state.onMessagesChange = handle
    },
    setMessages (state, messages) {
      state.messages = messages
    },
    messageSent (state) {
      state.messageSent = true
    }
  },
  getters: {
    loading: state => state.loading,
    user: state => state.user,
    messages: state => state.messages,
    messageSent: state => state.messageSent
  },
  actions: {
    login ({ commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
          commit('setUser', user)
          resolve()
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        firebase.auth().signOut().then(function () {
          resolve()
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    message ({ commit }, { name, email, text }) {
      return new Promise((resolve, reject) => {
        let messageId = firebase.database().ref().child('messages').push().key
        firebase.database().ref('messages/' + messageId).set({
          timestamp: Firebase.database.ServerValue.TIMESTAMP,
          name: name,
          email: email,
          text: text
        }).then(function () {
          resolve()
        }).catch(function (error) {
          reject(error)
        })
      })
    }
  }
})

export default store

// fb.ref("/.info/serverTimeOffset").on('value', function(offset) {
//    var offsetVal = offset.val() || 0;
//    var serverTime = Date.now() + offsetVal;
//  });

// function writeNewPost(uid, username, picture, title, body) {
//   // A post entry.
//   var postData = {
//     author: username,
//     uid: uid,
//     body: body,
//     title: title,
//     starCount: 0,
//     authorPic: picture
//   };
//
//   // Get a key for a new Post.
//   var newPostKey = firebase.database().ref().child('posts').push().key;
//
//   // Write the new post's data simultaneously in the posts list and the user's post list.
//   var updates = {};
//   updates['/posts/' + newPostKey] = postData;
//   updates['/user-posts/' + uid + '/' + newPostKey] = postData;
//
//   return firebase.database().ref().update(updates);
// }

// const store = new Vuex.Store()
// Assume there is a "login" module we wanna load
// import('./store/login').then(loginModule => {
//  store.registerModule('login', loginModule)
// })
// var user = {};
//
// function setUsers(data) {
//     for (var k in data) {
//         if (data.hasOwnProperty(k)) {
//            user[k] = data[k];
//         }
//     }
// }
// import VueFire from 'vuefire'
// import { VuexFire } from 'vuexfire'
// Vue.use(Firebase)
// Vue.use(VueFire)
// Vue.use(VuexFire)
// let database = firebase.database()
// let database = firebase.database()
// let productsRef = database.ref('products')
// firebase.auth().onAuthStateChanged(user => { });
// firebase.database().ref('/path/to/ref').on('value', snapshot => { });
// firebase.messaging().requestPermission().then(() => { });
// firebase.storage().ref('/path/to/ref').getDownloadURL().then(() => { });
// try {
//   let app = firebase.app();
//   let features = ['auth', 'database', 'messaging', 'storage'].filter(feature => typeof app[feature] === 'function');
//   document.getElementById('load').innerHTML = `Firebase SDK loaded with ${features.join(', ')}`;
// } catch (e) {
//   console.error(e);
//   document.getElementById('load').innerHTML = 'Error loading the Firebase SDK, check the console.';
// }



// WEBPACK FOOTER //
// ./src/store/index.js